import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTA() {
  return <section className="w-full bg-black py-20 px-4" data-id="element-164">
      <div className="max-w-4xl mx-auto text-center" data-id="element-165">
        {/* Logo */}
        <div className="text-[#00B4D8] text-3xl font-black tracking-widest mb-8" data-id="element-166">
          🇫🇷 PROFEPACK™
        </div>

        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3" data-id="element-167">
          El próximo domingo podés seguir buscando material en Google.
        </h2>
        <p className="text-[#00B4D8] text-2xl sm:text-3xl font-black mb-10" data-id="element-168">
          O podés tener todo resuelto desde hoy.
        </p>

        {/* Cost Table */}
        <div className="bg-[#001a2d] border border-[#00B4D8]/30 rounded-2xl overflow-hidden mb-12 max-w-2xl mx-auto text-left" data-id="element-169">
          <div className="p-4 bg-[#000d1a] border-b border-[#00B4D8]/30 text-center font-bold text-white" data-id="element-170">
            ¿Cuánto cuesta realmente NO tenerlo?
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-171">
            <div className="p-4 text-gray-400 text-sm" data-id="element-172">
              3 horas de planificación por semana × 40 semanas
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-173">
              120 horas de tu vida por año
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-174">
            <div className="p-4 text-gray-400 text-sm" data-id="element-175">
              Evaluaciones sin solucionario × 30 alumnos × 3 trimestres
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-176">
              Sábados de corrección sin criterios claros
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-177">
            <div className="p-4 text-gray-400 text-sm" data-id="element-178">
              Material adaptado para NEE inventado en el momento
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-179">
              Riesgo pedagógico + desgaste docente
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-180">
            <div className="p-4 text-gray-400 text-sm" data-id="element-181">
              Explicación del subjonctif sin diagrama visual
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-182">
              Alumnos que "saben la regla" pero no la aplican
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-183">
            <div className="p-4 text-gray-400 text-sm" data-id="element-184">
              Clases sin oralidad porque "da miedo" implementarla
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-185">
              Alumnos que aprueban escrito pero no hablan
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-186">
            <div className="p-4 text-gray-400 text-sm" data-id="element-187">
              Grupos A1+A2 sin sistema de diferenciación
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-188">
              Alumnos que se pierden y no vuelven al francés
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2" data-id="element-189">
            <div className="p-4 text-gray-400 text-sm" data-id="element-190">
              Domingo a la noche buscando actividades
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#00B4D8]/5 sm:border-l border-gray-800" data-id="element-191">
              El ciclo empieza de nuevo cada semana
            </div>
          </div>
        </div>

        {/* Countdown */}
        <div className="mb-4" data-id="element-192">
          <p className="text-white font-bold mb-4" data-id="element-193">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <CountdownTimer size="lg" blinking={true} data-id="element-194" />
        </div>
        <p className="text-gray-300 text-sm mb-12" data-id="element-195">
          Después sube{' '}
          <span className="text-[#FF0000] font-bold" data-id="element-196">$8.000 ARS</span> y no
          vuelve.
        </p>

        {/* 2 mini pricing cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10 max-w-2xl mx-auto" data-id="element-197">
          <div className="bg-[#0a0a0a] border border-[#00B4D8]/30 rounded-xl p-6 text-center flex flex-col" data-id="element-198">
            <div className="text-2xl mb-2" data-id="element-199">📘</div>
            <h3 className="text-white font-black mb-1" data-id="element-200">MEGAPACK FRANCÉS</h3>
            <p className="text-gray-400 text-xs mb-4" data-id="element-201">6 Tomos + 6 Bonos</p>
            <div className="mt-auto" data-id="element-202">
              <p className="text-[#00B4D8] text-2xl font-black mb-4" data-id="element-203">
                $19.990 ARS
              </p>
              <a href="https://www.profepack.com/cart/48159765070080:1" className="btn-green-pulse block bg-[#00B4D8] text-black font-black py-4 rounded-lg hover:bg-[#38BDF8] transition-colors text-sm" data-id="element-204">
                → QUIERO MI MEGAPACK
              </a>
            </div>
          </div>

          <div className="bg-[#000d1a] border-2 border-[#00B4D8] rounded-xl p-6 text-center shadow-[0_0_30px_rgba(0,180,216,0.2)] flex flex-col" data-id="element-205">
            <div className="text-2xl mb-2" data-id="element-206">🏆</div>
            <h3 className="text-[#00B4D8] font-black mb-1" data-id="element-207">
              MEGAPACK + ADAPTACIONES ⭐
            </h3>
            <p className="text-gray-400 text-xs mb-4" data-id="element-208">
              6 Tomos + 6 Bonos + Kit Adaptaciones al Aula Pro
            </p>
            <div className="mt-auto" data-id="element-209">
              <p className="text-[#00B4D8] text-3xl font-black mb-4" data-id="element-210">
                $27.990 ARS
              </p>
              <a href="https://www.profepack.com/cart/48159768019200:1" className="btn-green-pulse block bg-[#00B4D8] text-black font-black py-4 rounded-lg hover:bg-[#38BDF8] transition-colors text-sm" data-id="element-211">
                → QUIERO EL MEGAPACK + ADAPTACIONES
              </a>
            </div>
          </div>
        </div>

        {/* Final trust bar */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-gray-300" data-id="element-212">
          <span data-id="element-213">🔒 Pago 100% seguro</span>
          <span data-id="element-214">⚡ Acceso en 5 minutos</span>
          <span data-id="element-215">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-216">
            💳 Mercado Pago | Tarjeta de crédito | Transferencia bancaria
          </span>
        </div>
      </div>
    </section>;
}